import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getMyShopCouponList = async (params: object) => {
  return await POST({
    url: Api.getMyShopCouponList,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
